import { pick } from 'lodash';
import { COMMON_DISPLAY_FIELDS_KEYS, CONTENT_LIST_SIZES, CONTENT_TYPES, } from './constants';
export const getGroupPresentationImageWrapperSizes = (size) => {
    if (size === CONTENT_LIST_SIZES.SMALL) {
        return {
            maxWidth: { _: '130px', m: '100px' },
            minWidth: { _: '130px', m: '100px' },
            mr: 3,
        };
    }
    return {
        maxWidth: { _: '221px', m: '185px' },
        minWidth: { _: '221px', m: '185px' },
        mr: 5,
    };
};
export const getEventPresentationImageWrapperSizes = (size) => {
    if (size === CONTENT_LIST_SIZES.HIGHLIGHT) {
        return {
            width: '100%',
            maxWidth: { _: '100%', m: '283px' },
        };
    }
    if (size === CONTENT_LIST_SIZES.SMALL) {
        return {
            width: '72px',
            maxHeight: '72px',
        };
    }
    return {
        width: '186px',
        maxHeight: '105px',
    };
};
export const getDisplayFields = ({ displayFields, item, }) => {
    var _a, _b;
    if (!displayFields) {
        return item.displayFields;
    }
    let displayFieldsForType = displayFields[item.contentType];
    if (item.contentType === CONTENT_TYPES.FILEFOLDER) {
        displayFieldsForType =
            (_a = displayFields[CONTENT_TYPES.FILE]) !== null && _a !== void 0 ? _a : displayFields[CONTENT_TYPES.FOLDER];
    }
    const itemDisplayFields = (_b = item.displayFields) !== null && _b !== void 0 ? _b : displayFieldsForType;
    return Object.assign(pick(displayFields, COMMON_DISPLAY_FIELDS_KEYS), itemDisplayFields);
};
//# sourceMappingURL=utils.js.map